import { RouterModule, Routes } from '@angular/router';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { VmeCommonModule } from '../../vme-common.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VehicleLifecycleComponent } from './vehicle-lifecycle.component';

const routes: Routes = [
  { path: '', component: VehicleLifecycleComponent, data: { title: 'Vehicle LifeCycle' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  declarations: [],
})
export class VehicleLifeCycleRoutingModule {}

@NgModule({
  imports: [
    VehicleLifeCycleRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [VehicleLifecycleComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class VehicleLifeCycleModule {}
